import { createFileRoute, retainSearchParams, stripSearchParams } from '@tanstack/react-router';
import { fallback } from '@tanstack/router-zod-adapter';
import { z } from 'zod';
import { Timescale } from '../../components/PortfolioOverviewPage/AccountSnapshot/AccoutSnapshot.types';
import { PORTFOLIO_OVERVIEW_ROUTE_URL } from '../../constants/routes';

const searchDefaults = {
  tableTab: 'balances',
  chartTab: 'account',
  timescale: Timescale.all,
} as const;

const portfolioSearchSchema = z.object({
  tableTab: fallback(
    z.enum(['balances', 'transfers']).default(searchDefaults.tableTab),
    searchDefaults.tableTab
  ),
  chartTab: fallback(
    z.enum(['account', 'pnl']).default(searchDefaults.chartTab),
    searchDefaults.chartTab
  ),
  timescale: fallback(z.nativeEnum(Timescale).default(Timescale.all), searchDefaults.timescale),
});
export const Route = createFileRoute(PORTFOLIO_OVERVIEW_ROUTE_URL)({
  validateSearch: portfolioSearchSchema,
  search: {
    middlewares: [stripSearchParams(searchDefaults), retainSearchParams(true)],
  },
});
